"use client";

import React, { useContext } from "react";
import classNames from "classnames";
import Wrapper from "../Wrapper";
import RichText from "@/components/organisms/Richtext";
import { DisclaimerProps } from "./types";
import "./styles.scss";
import { GlobalContext } from "@/contexts/SiteDataContext";

const HEADER_DISCLAIMER_KEY = "header_disclaimer";

const Disclaimer: React.FC<DisclaimerProps> = ({ bigMaxWidth = false, className }) => {
  const { t, siteDataComplete } = useContext(GlobalContext).context;
  const classnames = classNames("disclaimer", {
    [className!]: !!className,
    "disclaimer--big-max-width": bigMaxWidth,
  });

  return (
    <div className={classnames}>
      <Wrapper>
        <RichText
          t={t}
          content={[HEADER_DISCLAIMER_KEY]}
          siteDataComplete={siteDataComplete}
        />
      </Wrapper>
    </div>
  );
};

export default Disclaimer;
